export const server = process.env.NEXT_PUBLIC_SERVER_URL || '';
export const TrackingID = process.env.NEXT_PUBLIC_GA_TRACKING_ID || '';
export const GtmID = process.env.NEXT_PUBLIC_GTM || '';
export const pixelID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID || '';
export const authCookieName = 'auth-token';
